import { PaymentFee } from '@qvs/core';

export const fees: PaymentFee[] = [
  { id: 'SHARED', name: 'payments.FEE_NAME_SHARED', description: 'payments.FEE_DESCRIPTION_SHARED' },
  { id: 'BENEFICIARY', name: 'payments.FEE_NAME_BENEFICIARY', description: 'payments.FEE_DESCRIPTION__BENEFICIARY' },
  { id: 'SENDER', name: 'payments.FEE_NAME_SENDER', description: 'payments.FEE_DESCRIPTION__SENDER' }
];
